import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { InfoGroupComponent, ItemComponent, ListDetailComponent } from '@tecalisdev/infinity';

@Component({
	selector: 'app-form-step-yes-no-preview',
	imports: [TranslatePipe, ItemComponent, ListDetailComponent, InfoGroupComponent],
	templateUrl: './form-step-yes-no-preview.component.html',
	styleUrl: './form-step-yes-no-preview.component.scss',
})
export class FormStepYesNoPreviewComponent {
	public readonly optionLabelKeys = [
		'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.PRESET_YES_NO_OPTION_YES',
		'WORKFLOWS.FORM.OPERATIONS.MODAL_FORM_STEP.PRESET_YES_NO_OPTION_NO',
	] as const;
}
